import JSZip from 'jszip';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorData } from '@/utils/error-report/ErrorData';
import { apiPath } from '@/redux/apiPath';
import { showToast } from '@/utils/showToast';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';

export const sendReport = createAsyncThunk('error/report', async (errorData: ErrorData) => {
  try {
    const zip = new JSZip();
    zip.file('report.json', JSON.stringify(errorData));
    const blob = await zip.generateAsync({ type: 'blob' });
    const formData = new FormData();
    formData.append('file', blob, 'report.zip');
    await axiosInstanceNewAPI.post(apiPath.submitErrorAsZip(), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    showToast({ type: 'success', message: 'Error report sent successfully.' });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    showToast({
      type: 'error',
      message: 'Unexpected error. More information can be found in the console.',
    });
  }
});
